import img1 from "../../../assets/img/imagination/p1.jpg";
import img2 from "../../../assets/img/imagination/p2.png";
import img3 from "../../../assets/img/imagination/p3.jpg";

export const DiscoverData = [
  {
    img: img1,
    heading: "Corporate Travel",
    // span: "Read More",
  },
  {
    img: img2,
    heading: "Worldwide Visa ",
    // span: "Read More",
  },
  {
    img: img3,
    heading: "Holidays and Leisure ",
    // span: "Read More",
  },
];
